import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {GroupPricingsListHeader} from './components/header/GroupPricingsListHeader'
import {GroupPricingsTable} from './table/GroupPricingsTable'
import { GroupPricingEditModal } from './GroupPricing-edit-modal/GroupPricingEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const GroupPricingsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <GroupPricingsListHeader />
        <GroupPricingsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <GroupPricingEditModal />}
    </>
  )
}

const GroupPricingsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <GroupPricingsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {GroupPricingsListWrapper}
